import React, { useState, useContext } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../components/AuthContext";
import { InfoContext } from "../components/InfoContext";
import { useAlert } from "../components/AlertContext";
import { PlatformContext } from "../components/Platform/PlatformContext";

import Button from "../components/Form/Button";
import InputField from "../components/Form/InputField";
import ImageBanner from "../components/ImageBanner";
import OrDivider from "../components/OrDivider";

const server_url = process.env.REACT_APP_BACKEND_URL;

const Login: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { setSession } = useContext(AuthContext);
  const { fetchSeasons, fetchTeams } = useContext(InfoContext);
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const platform = useContext(PlatformContext);
  const isMobile = !platform?.isDesktop;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true)
    try {
      const response = await axios.post(`${server_url}/login`, {
        email,
        password,
      });
      if (response.data.status) {
        // console.log("Login successfull:", response.data.data);
        setSession(response.data.data.session);
        showAlert("success", "Login successfull!");
        await Promise.all([fetchSeasons(), fetchTeams()]);
        navigate("/dashboard");
      } else {
        if (response.data.error === "invalid_credentials") {
          // console.log("Wrong Password or E-Mail");
          showAlert("error", "Wrong Password or E-Mail");
        } else if (response.data.error === "email_not_confirmed") {
          // console.log("Wrong Password or E-Mail");
          showAlert("warning", "Please confirm your email before logging in!");
        } else {
          // console.log("Error with logging in: ", response.data.error);
          showAlert("error", "Login failed: " + response.data.error);
        }
      }
    } catch (error: any) {
      
      // console.log("Login-Fehler:", error);
      showAlert(
        "error",
        "Login failed: " + (error.response?.data || error.message)
      );
      showAlert('error', 'Login failed: ' + (error.response?.data || error.message));
    } finally {
      setPassword("");
      setSubmitted(false)
    }
  };

  return (
    <>
      <ImageBanner title="Login" />
      {/*Paragraph Section */}
      <div className="w-full flex items-center justify-center">
        <p className="mx-10 text-center font-semibold text-white">
          Login or sign up to manage your team!
        </p>
      </div>

      {/* Form Section */}
      <div className={"flex flex-col items-center  h-full bg-inherit "}>
        <form
          onSubmit={handleSubmit}
          className={
            (isMobile ? "px-10 " : "") +
            "pt-6 rounded shadow-md w-full max-w-sm text-white "
          }
        >
          <InputField
            type="email"
            placeholder="Email"
            value={email}
            className="mb-3 max-w-sm "
            onChange={(e) => setEmail(e.target.value)}
            required={true}
            isMobile={isMobile}
          />
          <InputField
            type="password"
            placeholder="Password"
            value={password}
            className="mb-10 "
            onChange={(e) => setPassword(e.target.value)}
            required={true}
            isMobile={isMobile}
          />

          <div className={(isMobile ? "" : "") + " ml-1 text-sm -mt-2"}>
            <Link
              className={
                (isMobile ? "" : "ml-1") + " text-blue-600 hover:text-blue-800 inline"
              }
              to="/requestnewpassword"
            >
              <span className="text-gray-300">Reset your </span> password 
            </Link>

            <span className="text-gray-300 mx-2">or</span>

            <Link
              className="text-blue-600 hover:text-blue-800 inline"
              to="/resendverification"
            >
              <span className="text-gray-300">resend </span> verification! 
            </Link>
          </div>

          <Button className="mt-5 " text="Login" type="submit" />
          <div className="mb-0"></div>
        </form>
        <OrDivider isMobile={isMobile} />

        <div
          className={
            (isMobile ? "px-10 " : "") + "justify-center w-full max-w-sm "
          }
        >
          <Button
            text="Sign Up"
            type="button"
            onClick={() => navigate("/signup")}
          />
        </div>
      </div>
    </>
  );
};

export default Login;
